<template>
  <div class="bundlesPage pt-8 mx-auto w-10/12">
    <div class="flex flex-row">
      <div>
        <legend class="flex text-3xl text-pdsPrimaryColor font-light">
          Ondertekening succesvol
        </legend>
        <legend class="text-base text-tdefault-color my-2">
          Uw machtiging voor de patiënt is aangemaakt
        </legend>
      </div>
    </div>
    <div v-if="showBundles" class="grid grid-rows gap-2">
      <div v-if="bundles.illnessBundle && bundles.illnessBundle.length > 0" class="">
        <legend class="text-base text-tdefault-color mt-2 mb-4">
          Wij denken dat de volgende bestelpakketten relevant zijn voor deze patiënt:
        </legend>
        <v-bundles :bundles="bundles.illnessBundle" />
      </div>
      <div v-else>
        <legend class="text-base text-tdefault-color mt-4">
          Voor het uitzoeken en bestellen van producten navigeert u naar de catalogus.
        </legend>
      </div>
    </div>
    <div class="flex justify-start my-2" :class="{ 'border-t-2 border-white': showBundles }">
      <legend class="text-base text-tdefault-color" :class="{ 'mt-4': showBundles }">
        Voor het uitzoeken en bestellen van producten navigeert u naar de catalogus:
      </legend>
    </div>
    <div class="flex justify-start gap-2 mt-4">
      <button
        @click.prevent="$router.push('/patientdashboard')"
        class="flex justify-center py-2 px-2 md:px-4 border border-primary-color shadow-sm text-xs md:text-sm lg:text-sm font-medium text-primary-color bg-white rounded-full hover:bg-primary-default/50 items-center mr-2"
      >
        <span class=""> Ga naar dashboard van patiënt</span>
      </button>
      <button
        @click.prevent="$router.push('/catalog')"
        class="flex justify-center py-2 px-4 text-sm font-medium text-white items-center bg-primary-default border border-primary-default rounded-full"
      >
        <span>Naar catalogus</span>
      </button>
    </div>
  </div>
</template>

<script>
import VBundles from '@/components/sections/catalog/Bundles';
import axios from 'axios';
import { useStore } from 'vuex';
import router from '@/router';
import { ref, onMounted, computed } from 'vue';

export default {
  name: 'Bundles',
  components: {
    VBundles
  },
  setup() {
    const store = useStore();
    const siteCode = store.state.navigation.siteCode;
    const bundles = ref({});

    const showBundles = computed(() => {
      return router.currentRoute.value.params?.treatmentAreaId === '1004';
    });
    const showCatalog = computed(() => {
      return siteCode.value !== 'MIF';
    });

    onMounted(() => {
      axios.get('Products/GetIllnessBundle').then((response) => {
        if (response && response.data) {
          bundles.value = response.data;
        }
      });
    });

    return {
      siteCode,
      bundles,
      showBundles,
      showCatalog
    };
  }
};
</script>
